<template>
  <b-col sm="12" :lg="size" :offset="offset">
    <DateModal
      v-if="chartType != 'Shipped' && chartType != 'Received'"
      :modalID="chartType"
      :fetchData="fetchData"
      :dateFrom="dateFrom"
      :dateTo="dateTo"
      @date-picker-modal-emit="onDatePickerModalEmit"
    ></DateModal>
    <DateProductManufacturerModal
      v-if="chartType === 'Shipped' || chartType === 'Received'"
      :modalID="chartType"
      :fetchData="fetchData"
      :dateFrom="dateFrom"
      :dateTo="dateTo"
      @date-picker-modal-emit="onDateProductPickerModalEmit"
    ></DateProductManufacturerModal>
    <b-card class="backClass" style="min-height: 587px">
      <div
        slot="header"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <HeaderTitle
          :title="title"
          :dateFrom="from ? from : dateFrom"
          :dateTo="to ? to : dateTo"
        ></HeaderTitle>
        <HeaderControl
          :showFullscreenIcon="true"
          :showDateIcon="true"
          :showDownloadPdfIcon="true"
          @emit-fullscreen="toggleFullScreen"
          @emit-date="modalDateEvent(chartType)"
          @emit-pdf-download="downloadPDF"
        ></HeaderControl>
      </div>
      <div
        style="width: 100%; display: flex; justify-content: flex-end"
        v-if="withFinancial"
      >
        <h5>Quantity</h5>
        <c-switch
          class="mx-1"
          color="primary"
          v-model="valueQuantity"
          value="true"
          uncheckedValue="false"
          variant="pill"
        />
        <h5>Financials</h5>
      </div>
      <div class="chart-wrapper">
        <div v-if="loadingData" class="centered_container">
          <LoadingCard></LoadingCard>
        </div>
        <highcharts
          ref="backRef"
          v-else
          :options="chartOptions"
          class="chart"
          :constructor-type="'chart'"
        />
      </div>
      <div slot="footer">
        <b-button
          :disabled="!showAll"
          class="btn-outline"
          variant="outline-primary"
          left
          @click="(showAll = false), fetchData()"
          >Top 10</b-button
        >
        <b-button
          :disabled="showAll"
          class="btn-outline float-right"
          variant="outline-primary"
          right
          @click="(showAll = true), fetchData()"
          >All Data</b-button
        >
        <b-button
          v-if="chartType === 'Shipped' || chartType === 'backlog' || chartType === 'Received'" 
          class="btn-outline float-right"
          style="margin-right: 10px"
          variant="outline-primary"
          right
          @click="showTableAll()"
          >Table View All Data</b-button
        >
      </div>
    </b-card>
  </b-col>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import exporting from "highcharts/modules/exporting";
import Datepicker from "vuejs-datepicker";
import DateModal from "../shared/DateModal.vue";
import DateProductManufacturerModal from "../shared/DateProductManufacturerModal.vue";
import HeaderControl from "../shared/HeaderControl.vue";
import HeaderTitle from "../shared/HeaderTitle.vue";
import LoadingCard from "../shared/LoadingCard.vue";
import { chartFunctionsMixin } from "./addons/chartFunctionsMixin.js";
import { chartOptionsMixin } from "./addons/chartOptionsMixin.js";
exporting(Highcharts);

export default {
  mixins: [chartFunctionsMixin, chartOptionsMixin],
  components: {
    highcharts: Chart,
    Highcharts,
    Datepicker,
    cSwitch,
    DateModal,
    DateProductManufacturerModal,
    LoadingCard,
    HeaderTitle,
    HeaderControl,
  },
  props: [
    "size",
    "offset",
    "title",
    "withDate",
    "withFinancial",
    "chart",
    "chartType",
    "isCompanyOverall",
    "isCompanyProfile",
    "company",
    "city",
    "cityName",
    "model",
    "modelName",
  ],
  data: () => {
    return {
      dateFrom: "",
      dateTo: "",
      selectedProduct: "",
      selectedManufacturer: "",
    };
  },
  methods: {
    showTableAll() {
      this.$router.push(
        "/base/Tables/?type=" +
          this.chartType +
          "&date_from=" +
          this.dateFrom +
          "&date_to=" +
          this.dateTo +
          (this.selectedProduct
            ? "&productModel=" + this.selectedProduct.map(product => product.id).join(',')
            : "")
          +
          (this.selectedManufacturer
            ? "&thirdPartyClientId=" + this.selectedManufacturer.map(manufacturer => manufacturer.id).join(',')
            : "")
      );
    },
    onDateProductPickerModalEmit(
      changedDateFrom,
      changedDateTo,
      product,
      manufacturer
    ) {
      this.dateFrom = changedDateFrom;
      this.dateTo = changedDateTo;
      this.selectedProduct = product;
      this.selectedManufacturer = manufacturer;
    },
    fetchData() {
      this.loadingData = true;

      let finType = "Fin";
      if (!this.valueQuantity || this.valueQuantity == "false") {
        finType = "Qty";
      }
      let params = {};
      let link = null;
      if (this.isCompanyOverall) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/arris/company/chart_all.php`;
      } else if (this.isCompanyProfile) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/arris/company/chart_profile.php`;
      } else if (this.city) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/arris/charts/chart_city.php`;
      } else if (this.model) {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/arris/charts/chart_product.php`;
      } else {
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/arris/charts/chart_data.php`;
      }

      params = {
        type: finType,
        date_from: this.from,
        date_to: this.to,
        chartType: this.chartType,
        company: this.company ? this.company : "",
        client: this.city,
        model: this.model,
        productModel: this.selectedProduct ? this.selectedProduct.map(product => product.id).join(',') : "",
        thirdPartyClientId: this.selectedManufacturer ? this.selectedManufacturer.map(manufacturer => manufacturer.id).join(',') : "",
      };

      this.$http.get(link, { params }).then(
        (res) => {
          if (
            res.data &&
            (res.data.upData || res.data.dnData || res.data.totals)
          ) {
            let tmp = res.data.upData;
            tmp &&
              tmp.length > 0 &&
              tmp.sort((a, b) =>
                parseFloat(a.locationTotal) > parseFloat(b.locationTotal)
                  ? -1
                  : 1
              );

            let smp = res.data.dnData;
            smp && smp.length > 0
              ? smp.forEach((value) => {
                  value.data.sort((a, b) =>
                    parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
                  );
                })
              : "";
            if (tmp && tmp.length > 0)
              if (!this.showAll) {
                this.chartOptions.series[0].data = tmp.slice(0, 10);
              } else {
                this.chartOptions.series[0].data = tmp;
              }
            if (!this.isCompanyProfile) {
              this.chartOptions.drilldown.series = smp;
            }
            if (this.isCompanyOverall) {
              this.chartOptions.drilldown.series = null;
            }
            if (this.isCompanyProfile) {
              this.chartOptions.drilldown.series = null;
            }
            if (this.model) {
              this.chartOptions.drilldown.series = null;
            }

            if (finType == "Fin") {
              this.chartOptions.title.text =
                "Total : $" +
                res.data.totals
                  .toFixed(2)
                  .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
            } else {
              this.chartOptions.title.text = "Total units: " + res.data.totals;
            }

            this.loadingData = false;
            setTimeout(() => {
              this.changeHeight();
            });
          } else {
            this.loadingData = false;
          }
        },
        (err) => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-exporting-group {
  display: none !important;
}
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
.centered_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
